export default "__VITE_ASSET__Dm298tX9__"